<template>
  <footer id="footer-calculadora">
    <div class="fc-container">
      <div class="fc-main">
        <!-- =================================================
             MARCA
        ================================================== -->
        <div class="fc-brand">
          <strong class="fc-name"> Calculadora de Fletes </strong>
          <p class="fc-description">
            Calcula una estimación de los costos de transporte internacional de
            tu carga y obtén información clara para planificar mejor tu
            operación.
          </p>
          <span class="fc-line-blue" aria-hidden="true"></span>
        </div>

        <!-- =================================================
             INFORMACIÓN
        ================================================== -->
        <div class="fc-info">
          <strong class="fc-heading"> Información de contacto </strong>
          <ul class="fc-info-list">
            <li class="fc-info-item">
              <span class="fc-info-icon" aria-hidden="true">
                <i class="fa-solid fa-location-dot"></i>
              </span>
              <span>
                Av. Agustín Rosa Toro 770,<br />
                San Luis, Lima, Perú
              </span>
            </li>
            <li class="fc-info-item">
              <span class="fc-info-icon" aria-hidden="true">
                <i class="fa-solid fa-envelope"></i>
              </span>
              <a href="mailto:asesoramiento@pic-cargo.com">
                asesoramiento@pic-cargo.com
              </a>
            </li>
            <li class="fc-info-item">
              <span class="fc-info-icon" aria-hidden="true">
                <i class="fa-solid fa-phone"></i>
              </span>
              <a href="tel:+51906931842"> +51 906 931 842 </a>
            </li>
          </ul>
        </div>

        <!-- =================================================
             CONTACTO
        ================================================== -->
        <div class="fc-contact">
          <strong class="fc-heading"> ¿Necesitas ayuda? </strong>
          <p class="fc-contact-text">
            Nuestro equipo puede orientarte si tienes dudas durante tu proceso
            de cotización.
          </p>
          <a
            class="fc-contact-button"
            href="https://api.whatsapp.com/send?phone=51906931842&text=Hola%2C%20visité%20www.calculadoradefletes.com%20y%20quiero%20más%20información."
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contactar por WhatsApp"
          >
            <i class="fa-brands fa-whatsapp" aria-hidden="true"></i>
            <span>Contactar</span>
          </a>
        </div>
      </div>

      <!-- =================================================
           PARTE INFERIOR
      ================================================== -->
      <div class="fc-bottom">
        <p class="fc-copy">
          © 2026 Calculadora de Fletes. Todos los derechos reservados.
        </p>
        <p class="fc-tagline">Transporte internacional · Perú</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "CalculadoraFooter",
};
</script>

<style scoped>
/* Importación de Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap");

/* Importación de FontAwesome (Alternativamente, puedes colocar el <link> en tu public/index.html) */
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css");

/* =====================================================
   AISLAMIENTO
===================================================== */
#footer-calculadora,
#footer-calculadora *,
#footer-calculadora *::before,
#footer-calculadora *::after {
  box-sizing: border-box;
}

/* =====================================================
   FOOTER GENERAL
===================================================== */
#footer-calculadora {
  --fc-font: "Montserrat", system-ui, -apple-system, "Segoe UI", Roboto, Arial,
    sans-serif;
  --fc-bg: #032b45;
  --fc-bg-deep: #02253b;
  --fc-blue: #0878e8;
  --fc-blue-hover: #006bd7;
  --fc-white: #ffffff;
  --fc-text: #dce6ed;
  --fc-muted: #a7bbc9;
  --fc-line: rgba(255, 255, 255, 0.13);

  width: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, var(--fc-bg) 0%, var(--fc-bg-deep) 100%);
  color: var(--fc-white);
  font-family: var(--fc-font);
}

#footer-calculadora::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
}

/* =====================================================
   CONTENEDOR
===================================================== */
#footer-calculadora .fc-container {
  width: min(calc(100% - 80px), 1380px);
  margin: 0 auto;
}

/* =====================================================
   ZONA SUPERIOR
===================================================== */
#footer-calculadora .fc-main {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(240px, 0.8fr) minmax(
      260px,
      0.8fr
    );
  align-items: start;
  gap: clamp(55px, 6vw, 95px);
  padding: 66px 0 58px;
}

/* =====================================================
   MARCA
===================================================== */
#footer-calculadora .fc-brand {
  max-width: 500px;
}

#footer-calculadora .fc-name {
  margin: 0;
  display: block;
  color: #ffffff;
  font-size: 27px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.6px;
}

#footer-calculadora .fc-description {
  max-width: 470px;
  margin: 17px 0 0;
  color: var(--fc-muted);
  font-size: 15px;
  line-height: 1.75;
  font-weight: 400;
}

#footer-calculadora .fc-line-blue {
  width: 38px;
  height: 3px;
  display: block;
  margin-top: 22px;
  background: var(--fc-blue);
}

/* =====================================================
   TÍTULOS
===================================================== */
#footer-calculadora .fc-heading {
  display: block;
  margin: 2px 0 20px;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 700;
}

/* =====================================================
   INFORMACIÓN
===================================================== */
#footer-calculadora .fc-info-list {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 16px;
  list-style: none;
}

#footer-calculadora .fc-info-item {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  gap: 11px;
  align-items: start;
  margin: 0;
  padding: 0;
  color: var(--fc-muted);
  font-size: 14px;
  line-height: 1.6;
}

#footer-calculadora .fc-info-icon {
  width: 18px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #65b3f8;
  font-size: 13px;
}

#footer-calculadora .fc-info-item a {
  color: var(--fc-text);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

#footer-calculadora .fc-info-item a:hover {
  color: #ffffff;
}

/* =====================================================
   CONTACTO
===================================================== */
#footer-calculadora .fc-contact-text {
  max-width: 310px;
  margin: 0;
  color: var(--fc-muted);
  font-size: 14px;
  line-height: 1.68;
}

/* =====================================================
   BOTÓN
===================================================== */
#footer-calculadora .fc-contact-button {
  width: 100%;
  max-width: 260px;
  min-height: 52px;
  margin-top: 21px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid var(--fc-blue);
  border-radius: 3px;
  background: var(--fc-blue);
  color: #ffffff;
  font-family: var(--fc-font);
  font-size: 14px;
  line-height: 1;
  font-weight: 700;
  text-decoration: none;
  box-shadow: none;
  transition: background-color 0.22s ease, border-color 0.22s ease,
    transform 0.22s ease;
}

#footer-calculadora .fc-contact-button i {
  font-size: 18px;
}

#footer-calculadora .fc-contact-button:hover {
  background: var(--fc-blue-hover);
  border-color: var(--fc-blue-hover);
  transform: translateY(-2px);
}

#footer-calculadora .fc-contact-button:focus-visible {
  outline: 3px solid rgba(101, 179, 248, 0.4);
  outline-offset: 4px;
}

/* =====================================================
   PARTE INFERIOR
===================================================== */
#footer-calculadora .fc-bottom {
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  border-top: 1px solid var(--fc-line);
}

#footer-calculadora .fc-copy,
#footer-calculadora .fc-tagline {
  margin: 0;
  color: #8199aa;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
}

#footer-calculadora .fc-tagline {
  text-align: right;
}

/* =====================================================
   TABLET
===================================================== */
@media (max-width: 1050px) {
  #footer-calculadora .fc-container {
    width: min(calc(100% - 52px), 940px);
  }
  #footer-calculadora .fc-main {
    grid-template-columns: minmax(0, 1fr) minmax(250px, 0.8fr);
    gap: 48px 65px;
    padding: 56px 0 50px;
  }
  #footer-calculadora .fc-brand {
    grid-column: 1 / -1;
    max-width: 650px;
  }
  #footer-calculadora .fc-description {
    max-width: 600px;
  }
  #footer-calculadora .fc-contact-button {
    max-width: 100%;
  }
}

/* =====================================================
   MÓVIL
===================================================== */
@media (max-width: 700px) {
  #footer-calculadora .fc-container {
    width: calc(100% - 34px);
  }
  #footer-calculadora .fc-main {
    grid-template-columns: 1fr;
    gap: 0;
    padding: 44px 0 36px;
  }
  #footer-calculadora .fc-brand {
    grid-column: auto;
    max-width: none;
    padding-bottom: 31px;
    border-bottom: 1px solid var(--fc-line);
  }
  #footer-calculadora .fc-name {
    font-size: 23px;
    line-height: 1.25;
  }
  #footer-calculadora .fc-description {
    max-width: none;
    margin-top: 14px;
    font-size: 14px;
    line-height: 1.7;
  }
  #footer-calculadora .fc-line-blue {
    margin-top: 20px;
  }
  #footer-calculadora .fc-info {
    padding: 30px 0;
    border-bottom: 1px solid var(--fc-line);
  }
  #footer-calculadora .fc-heading {
    margin: 0 0 17px;
    font-size: 13.5px;
  }
  #footer-calculadora .fc-info-list {
    gap: 14px;
  }
  #footer-calculadora .fc-info-item {
    font-size: 13.5px;
    line-height: 1.6;
  }
  #footer-calculadora .fc-contact {
    padding-top: 30px;
  }
  #footer-calculadora .fc-contact-text {
    max-width: none;
    font-size: 13.5px;
    line-height: 1.65;
  }
  #footer-calculadora .fc-contact-button {
    width: 100%;
    max-width: none;
    min-height: 54px;
    margin-top: 19px;
    border-radius: 3px;
    font-size: 14px;
  }
  #footer-calculadora .fc-bottom {
    min-height: auto;
    padding: 20px 0 22px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 7px;
  }
  #footer-calculadora .fc-copy,
  #footer-calculadora .fc-tagline {
    font-size: 11.5px;
    text-align: left;
  }
}

/* =====================================================
   MÓVIL MUY PEQUEÑO
===================================================== */
@media (max-width: 390px) {
  #footer-calculadora .fc-container {
    width: calc(100% - 28px);
  }
  #footer-calculadora .fc-name {
    font-size: 21px;
  }
  #footer-calculadora .fc-description {
    font-size: 13.5px;
  }
  #footer-calculadora .fc-info-item {
    grid-template-columns: 17px minmax(0, 1fr);
    gap: 9px;
    font-size: 13px;
  }
}

/* =====================================================
   REDUCIR MOVIMIENTO
===================================================== */
@media (prefers-reduced-motion: reduce) {
  #footer-calculadora .fc-contact-button,
  #footer-calculadora .fc-info-item a {
    transition: none;
  }
  #footer-calculadora .fc-contact-button:hover {
    transform: none;
  }
}
</style>
